import Vue from "vue";
import Vuex from "vuex";
import { getLocaleStorageItem } from "../core/utils/index";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

Vue.use(Vuex);

const state = {
  isLoggedIn: !!window.localStorage.getItem("gd_plus_token"),
  token: window.localStorage.getItem("gd_plus_token"),
  azcRefreshToken: window.localStorage.getItem("gd_plus_azc_refresh_token"),
  azcAccessToken: window.localStorage.getItem("gd_plus_azc_access_token"),
  user: JSON.parse(window.localStorage.getItem("gd_plus_user")),
  game: getLocaleStorageItem("gd_plus_game"),
  domain:
    window.localStorage.getItem("gd_plus_domain") ?? "gamedistribution.com",
  locale: window.localStorage.getItem("gd_plus_locale"),
  sso: false,
  unseenNotificationCount: null,
  notificationList: null
};

export default new Vuex.Store({
  state,
  mutations,
  getters,
  actions
});
